import React from 'react'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'
import Authorization from '../../Authentication/Authorization'
import ProtectedRoute from '../../components/ProtectedRoute'
import GatewayType from '../GatewayType'
import EncryptionKeys from './EncryptionKeys'
import KeyRotation from './KeyRotation'

const baseRoute = '/keys'
const subTabs = [
  { path: baseRoute + '/encryptionKeys', title: 'Encryption Keys', permissions: Authorization.keystore.keys.view, component: EncryptionKeys },
  { path: baseRoute + '/keyRotation', title: 'Key Rotation', permissions: Authorization.keystore.keyRotation, component: KeyRotation },
]

const Keys: GatewayType = () => {
  const match = useRouteMatch()
  return (
    <Switch>
      {subTabs.map((tab) => (
        <ProtectedRoute key={tab.path} path={tab.path} permissions={tab.permissions} Component={tab.component} />
      ))}
      <Route path={match.path}>
        <Redirect to={subTabs[0].path} />
      </Route>
    </Switch>
  )
}

Keys.subTabs = subTabs

export default Keys
